import React from 'react';
import { FormGroup, Label, LabelText, CopiedMessage, Input } from '@zen-common/components-base';
import { useCopy } from '@zen/common-react-hooks';

export default function CopyableExpandableFormGroup({ label, value }) {
  const [copied, copyError, onCopy] = useCopy({ value });

  const handleCopy = () => {
    if (value) {
      onCopy();
    }
  };

  return (
    <FormGroup>
      <Label>
        <LabelText>{label}</LabelText>
      </Label>
      <Input onClick={handleCopy} inputType="expandable" variant="block" readOnly value={value} />
      <CopiedMessage copied={copied} error={copyError} />
    </FormGroup>
  );
}
